@if (genderGroup) {
<div class="people-gender-panel-container" [formGroup]="genderGroup">
    <div class="select-label text-info-800">
        Add Optional Gender Tracking to Progress
        <app-help-selector [selector]="1215"></app-help-selector>
    </div>
    <div>Numbers must total progress value.</div>

    <div class="gender-grid">
        <div class="gender-row">
            <div class="gender-col label-col">Women</div>
            <div class="gender-col"><input matInput class="form-control" type="number" step="any"
                    (keydown)="preventScientificNotation($event)" (paste)="preventNonNumericPaste($event)"
                    formControlName="women" /></div>
            <div class="gender-col">People</div>
        </div>
        <div class="gender-row">
            <div class="gender-col label-col">Men</div>
            <div class="gender-col"><input matInput class="form-control" type="number" step="any"
                    (keydown)="preventScientificNotation($event)" (paste)="preventNonNumericPaste($event)" formControlName="men" />
            </div>
            <div class="gender-col">People</div>
        </div>
        <div class="gender-row">
            <div class="gender-col label-col">Non-Binary</div>
            <div class="gender-col"><input matInput class="form-control" type="number" step="any"
                    (keydown)="preventScientificNotation($event)" (paste)="preventNonNumericPaste($event)"
                    formControlName="nonBinary" /></div>
            <div class="gender-col">People</div>
        </div>
        <div class="gender-row">
            <div class="gender-col label-col">Prefer not to Say or N/A</div>
            <div class="gender-col"><input matInput class="form-control" type="number" step="any"
                    (keydown)="preventScientificNotation($event)" (paste)="preventNonNumericPaste($event)"
                    formControlName="preferNotToSay" /></div>
            <div class="gender-col">People</div>
        </div>
        <div class="gender-row total-row">
            <div class="gender-col label-col">Total</div>
            <div class="gender-col">
                <input matInput class="form-control total-input" type="text" readonly [value]="total" tabindex="-1" />
            </div>
            <div class="gender-col">People</div>
        </div>
        <div class="gender-row clear-row">
            <div class="gender-col label-col"></div>
            <div class="gender-col clear-btn-col">
                <button type="button" class="clear-button" (click)="clear()" [disabled]="!hasValues">CLEAR</button>
            </div>
            <div class="gender-col"></div>
        </div>
    </div>
    <div class="hub-validation-error-message" [class.show-error]="isGenderTotalInvalid">
        Numbers must equal total progress.
    </div>
</div>
}
